import $apiJSON from 'http/apiJSON'

const BASE = '/admin-panel'

export async function getMe() {
  return $apiJSON.get(`${BASE}/me/`)
}

export async function getDashboard() {
  return $apiJSON.get(`${BASE}/dashboard/`)
}

export async function listUsers(params = {}) {
  return $apiJSON.get(`${BASE}/users/`, { params })
}

export async function getUser(id) {
  return $apiJSON.get(`${BASE}/users/${id}/`)
}

export async function createUser(payload) {
  return $apiJSON.post(`${BASE}/users/`, payload)
}

export async function updateUser(id, payload) {
  return $apiJSON.patch(`${BASE}/users/${id}/`, payload)
}

export async function deleteUser(id) {
  return $apiJSON.delete(`${BASE}/users/${id}/`)
}

export async function grantRole(id, code) {
  return $apiJSON.post(`${BASE}/users/${id}/grant/`, { role_code: code })
}

export async function revokeRole(id, code) {
  return $apiJSON.post(`${BASE}/users/${id}/revoke/`, { role_code: code })
}

export async function lockUser(id) {
  return $apiJSON.post(`${BASE}/users/${id}/lock/`, {})
}

export async function unlockUser(id) {
  return $apiJSON.post(`${BASE}/users/${id}/unlock/`, {})
}

export async function resetPassword(id) {
  return $apiJSON.post(`${BASE}/users/${id}/reset-password/`, {})
}

export async function resetPin(id) {
  return $apiJSON.post(`${BASE}/users/${id}/reset-pin/`, {})
}

export async function listRoles(params = {}) {
  return $apiJSON.get(`${BASE}/roles/`, { params })
}

export async function createRole(payload) {
  return $apiJSON.post(`${BASE}/roles/`, payload)
}

export async function updateRole(id, payload) {
  return $apiJSON.patch(`${BASE}/roles/${id}/`, payload)
}

export async function deleteRole(id) {
  return $apiJSON.delete(`${BASE}/roles/${id}/`)
}

export async function seedDefaultRoles() {
  return $apiJSON.post(`${BASE}/roles/seed-defaults/`, {})
}

const activityParams = (params) => Object.fromEntries(Object.entries(params).filter(([, value]) => value !== '' && value != null))

export async function listActivity(params = {}) {
  return $apiJSON.get(`${BASE}/activity/`, { params: activityParams(params) })
}

export async function getActivity(id) {
  return $apiJSON.get(`${BASE}/activity/${id}/`)
}

export async function getActivityOptions(params = {}) {
  return $apiJSON.get(`${BASE}/activity/options/`, { params: activityParams(params) })
}

export async function listLoginAttempts(params = {}) {
  return $apiJSON.get(`${BASE}/login-attempts/`, { params })
}

export async function listSettings(params = {}) {
  return $apiJSON.get(`${BASE}/settings/`, { params })
}

export async function updateSetting(id, payload) {
  return $apiJSON.patch(`${BASE}/settings/${id}/`, payload)
}

export async function listIntegrations(params = {}) {
  return $apiJSON.get(`${BASE}/integrations/`, { params })
}

export async function createIntegration(payload) {
  return $apiJSON.post(`${BASE}/integrations/`, payload)
}

export async function updateIntegration(id, payload) {
  return $apiJSON.patch(`${BASE}/integrations/${id}/`, payload)
}

export async function deleteIntegration(id) {
  return $apiJSON.delete(`${BASE}/integrations/${id}/`)
}

export async function seedIntegrations() {
  return $apiJSON.post(`${BASE}/integrations/seed/`, {})
}

export default {
  getMe,
  getDashboard,
  listUsers,
  getUser,
  createUser,
  updateUser,
  deleteUser,
  grantRole,
  revokeRole,
  lockUser,
  unlockUser,
  resetPassword,
  resetPin,
  listRoles,
  createRole,
  updateRole,
  deleteRole,
  seedDefaultRoles,
  listActivity,
  getActivity,
  getActivityOptions,
  listLoginAttempts,
  listSettings,
  updateSetting,
}
